import { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cn from 'classnames';

import { createHeartList } from 'actions/hearts';
import modalCSS from 'styles/components/common/modal.scss';
import css from 'styles/components/account/collectionModals/newCollectionModal.scss';

export class NewCollectionModal extends Component {
  static contextTypes = {
    testId: PropTypes.func
  };

  onSaveNewCollection = e => {
    e.preventDefault();
    const { onDoneModal, createHeartList } = this.props;
    const { collectionName: { value } } = e.currentTarget;
    createHeartList({ listName: value }).then(onDoneModal);
  }

  render() {
    const { showNewCollectionModal, onDoneModal } = this.props;

    return (
      <Modal className={cn(modalCSS.modalContent, css.modal)} overlayClassName={modalCSS.modalOverlay} isOpen={showNewCollectionModal}>
        <div>
          <div className={cn(modalCSS.header, css.header)}>
            <h2>Create new Collection</h2>
            <button
              type="button"
              className={modalCSS.close}
              onClick={onDoneModal}
              aria-label="Close"
            />
          </div>

          <form method="post" onSubmit={this.onSaveNewCollection}>
            <div className={css.fields}>
              <label htmlFor="collectionName">Collection Name</label>
              <input name="collectionName" id="collectionName" type="text" />
            </div>

            <div className={css.footer}>
              <button type="button" onClick={onDoneModal}>Cancel</button>
              <button type="submit">Create</button>
            </div>
          </form>
        </div>
      </Modal>
    );
  }
}

export const mapStateToProps = () => ({});

export default connect(mapStateToProps, {
  createHeartList
})(NewCollectionModal);
